module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image01-1110x550@2x.6fe5d65a.jpg";